<template>
  <AdminLayout>
    <Head title="Company Users" />

    <template #sectionTitle> Settings </template>

    <template #pageTitle> Users </template>

    <div class="bg-gray-100 shadow px-4 py-4 rounded sm:rounded-lg sm:px-16 sm:py-12"></div>
  </AdminLayout>
</template>

<script>
import { computed } from 'vue'
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, usePage, useForm } from '@inertiajs/vue3'

export default {
  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {},

  setup() {
    return {}
  },

  methods: {
    submit() {}
  }
}
</script>
